import React from "react";
import style from "./../../IO/Fields/Fields.module.scss";
import { Field } from "../../Order/Field/Field";
import Autosuggest from "../../../Autosuggest/Autosuggest";
import { IOType } from "../../../IO/types";

const Symbol = ({ ioType, isCurrency, value, error, disabled, accountId, onChange, fetchSearchSymbol }) => {
  const fetchSearch = ({ value }) => {
    return fetchSearchSymbol({
      type: "Event",
      text: value,
      length: 10,
      accountId: ioType != null && ioType != IOType.Deposit ? accountId : 0,
    })
      .then((r) => r.response.symbols)
      .then((symbols) =>
        symbols.map((s) => ({
          id: s.Id,
          name: `${s.Ticker} ${isCurrency ? `- ${s.Description}` : ""}`,
          decimal: Number(s.decimal),
          Price: s.price,
        }))
      );
  };

  const internalOnChange = (method, value) => {
    const _value = {
      CurrencyId: null,
      CurrencyISO: "",
      AssetId: null,
      AssetTicker: "",
      decimal: 2,
    };
    if (method != "type" && value.id) {
      if (isCurrency) {
        _value.CurrencyId = value.id;
        _value.CurrencyISO = value.name;
        _value.decimal = 2;
      } else {
        _value.AssetId = value.id;
        _value.AssetTicker = value.name;
        _value.decimal = value.decimal;
        _value.Price = value.Price;
      }
    }

    onChange(_value);
  };

  return (
    <Field
      label={isCurrency ? "Currency" : "Asset"}
      error={error}
      description={
        ioType != null && ioType != IOType.Deposit && !accountId ? "Must select an account first" : null
      }
    >
      <Autosuggest
        renderSuggestion={(suggestion) => (
          <div className={style.suggestionItem}>
            <span>{suggestion.name}</span>
          </div>
        )}
        getSuggestionValue={(s) => `${s.name}`}
        onSuggestionsFetchRequested={fetchSearch}
        value={value || ""}
        inputProps={{
          placeholder: isCurrency ? "Currency" : "Asset",
          invalid: !!error,
          disabled: disabled || (ioType != null && ioType != IOType.Deposit && !accountId),
        }}
        onChange={(m, v) => internalOnChange(m, v)}
      />
    </Field>
  );
};

export default Symbol;
